export const FEATURE_FLAGS_WORKSHEET = 'Feature Flags';
export const FEATURE_FLAGS_RANGE = 'A2:D';

export const FEATURE_KEYS = {
  riderResults: 'rider-results',
  releaseHighlights: 'release-highlights',
} as const;

export type FeatureKey = typeof FEATURE_KEYS[keyof typeof FEATURE_KEYS];
export type FeatureFlagEnvironment = 'test' | 'prod';

export interface FeatureFlagRow {
  key: string;
  environment?: string;
  description?: string;
  notes?: string;
}

export type FeatureFlagReason =
  | 'enabled'
  | 'disabled'
  | 'unknown'
  | 'invalid'
  | 'duplicate'
  | 'unavailable'
  | 'environment-mismatch'
  | 'local-override';

export interface FeatureFlag {
  key: string;
  enabled: boolean;
  source: 'configured' | 'default' | 'local';
  reason: FeatureFlagReason;
  environment?: FeatureFlagEnvironment;
}

export interface FeatureFlagSet {
  flags: Record<string, FeatureFlag>;
  environment?: FeatureFlagEnvironment;
  isEnabled: (key: string) => boolean;
  getFlag: (key: string) => FeatureFlag;
}

export interface GatedSurface {
  featureKey: string;
  behavior: 'hide' | 'unavailable' | 'redirect';
}
